/* eslint-disable @typescript-eslint/no-explicit-any */
import { createSlice } from "@reduxjs/toolkit";
// import { InitialState } from "../interfaces/pricing.interfaces";
import { getPlanOptions } from "../actions/pricingDashboard.action";

const initialState: any = {};

const getPlansOptionsSlice = createSlice({
  name: "Get Plans",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(getPlanOptions.pending, (state) => {
      state.isLoading = true;
    });

    builder.addCase(getPlanOptions.fulfilled, (state, action) => {
      state.data = action.payload;
      state.isLoading = false;
    });

    builder.addCase(getPlanOptions.rejected, (state) => {
      state.isLoading = false;
    });
  },
});

export default getPlansOptionsSlice.reducer;
